import { render, staticRenderFns } from "./PriceUpdateDate.vue?vue&type=template&id=f5e4c892&scoped=true&"
import script from "./PriceUpdateDate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceUpdateDate.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceUpdateDate.vue?vue&type=style&index=0&id=f5e4c892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e4c892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5e4c892')) {
      api.createRecord('f5e4c892', component.options)
    } else {
      api.reload('f5e4c892', component.options)
    }
    module.hot.accept("./PriceUpdateDate.vue?vue&type=template&id=f5e4c892&scoped=true&", function () {
      api.rerender('f5e4c892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/PriceUpdateDate.vue"
export default component.exports